import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlanNotificationService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async GetCustomerDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetCustomerDropdownListValues`,obj,isformupload);    
}
 
async GetPlanNotificationList(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanNotificationList`,obj,isformupload);    
}

}
